import React, {useState} from 'react';
import classnames from 'classnames';
import {Popup, Cell, Button, Picker, Toast} from 'zarm';
import utils from '@seeing/utils';
import ExamItem from './ExamItem'; // 检查项
import Adapter from './adapter';
import {PREFIX} from './constant';
import debounce from 'lodash/debounce';
import Back from '../../../../static/image/back.png';
import request from '@utils/request';

import './index.less';

class ExamineTemplate extends React.Component {
  static defaultProps = {
    data: {}, // 检查项的数据
  };
  constructor(props) {
    super(props);
    // this.adapter = Adapter.init()
    const {data = {}} = props;
    const {examConfig = {}} = data;
    // 检查项的显示模式 Popup：从底部弹出 ，其他就是覆盖整个页面
    const {mode = 'Popup'} = examConfig;
    if (mode === 'FullPage') {
      document.body.style.height = '100vh';
      document.body.style.width = '100vw';
      document.body.style.overflow = 'hidden';
    }
    // 创建状态
    this.state = {
      data, // 检查项的数据
      visible: false,
      fullPageVisible: true,
      saveLoading: false
    };
    // 检查项实例
    this.examItemRef = React.createRef();
  }
  componentDidMount() {
    // this.init();
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const { data } = nextProps;
  //   if (data !== prevState.data) {
  //     return {
  //       data: nextProps.data,
  //     };
  //   }
  // }
  init() {
    const {data = {}} = this.props;
    // 初始化适配器
    this.adapter = Adapter.init(data);
    const values = JSON.parse(JSON.stringify(this.adapter.sourceData));
    // 设置数据
    this.setState({data: this.adapter.data});
  }
  /**
   * 关闭检查项的弹出层
   */
  handleClose = () => {
    this.setState({visible: false});
    document.body.style.overflow = 'initial';
  };
  /**
   * 打开弹出层
   */
  handleOpen = () => {};

  /**
   * 检查项的弹层显示与否
   * @param {*} visible
   */
  handleChangeVisible = (visible) => {
    const {data} = this.state;
    const {examConfig = {}} = data;
    // 检查项的显示模式 Popup：从底部弹出 ，其他就是覆盖整个页面
    const {mode = 'Popup'} = examConfig;
    mode === 'Popup'
      ? this.setState({visible})
      : this.handleFullPageHidden(visible);

    document.body.style.overflow = 'hidden';
  };

  // 换镜片 开始新验配流程
  exchangeLens = () => {
    this.props.onNoticeVisible();
  };
  /**
   * 保存
   */
  handleSave = debounce(() => {
    const {onSave = () => {}, data = {}} = this.props;
    const {isChangeStatus} = data;

    // 最终提交的数据
    const values =
      this.examItemRef?.current &&
      this.examItemRef.current.handleFinishCallback();
    if (values?.error) {
      return Toast.show({
        content: values.error,
        stayTime: 500,
      });
    }
    this.setState({ saveLoading: true})
    onSave &&
      onSave(values).then(() => {
        // // 改变状态
        // if (isChangeStatus) {
        //   this.handleChangeStatus();
        // }
        this.handleClose();
        this.handleFullPageHidden(false);
      }).finally(() => {
        this.setState({ saveLoading: false})
      });
  }, 500);
  /**
   * 改变状态
   */
  handleChangeStatus = () => {
    const {examCode, examId, tenantId, tempId, nodeId, examTimes} =
      this.props.data;
    const param = {
      examCode,
      examId,
      tenantId,
      examStatus: 1,
      tempId,
      nodeId,
      examTimes,
    };
    request.post('/form_designer/ok_treatment/ok_app/exam_state', {...param});
  };

  /**
   * 隐藏元素
   */
  handleFullPageHidden = (fullPageVisible) => {
    this.setState({fullPageVisible});
    document.body.style.overflow = fullPageVisible ? 'hidden' : 'scroll';
  };
  /**
   * 修改数据
   * @param {}} data
   */
  handleExamData = (data = {}) => {
    this.setState({data});
  };
  render() {
    const {data = {}, visible, fullPageVisible, saveLoading} = this.state;
    const {examConfig = {}, examName} = data;
    // 检查项的显示模式 Popup：从底部弹出 ，其他就是覆盖整个页面
    const {mode = 'Popup'} = examConfig;
    return (
      <div className={classnames({[PREFIX]: true})}>
        {mode === 'Popup'
          ? visible && (
              <Popup
                visible={visible}
                direction="bottom"
                onMaskClick={this.handleClose}
                afterOpen={this.handleOpen}
                afterClose={this.handleClose}
                destroy={false}
                mountContainer={() => document.body}
              >
                <div className="popup-box">
                  <div className="popup_header">
                    <div className="cancelBtn" onClick={this.handleClose}>
                      取消
                    </div>
                    <div className="title">{examName}</div>
                    <Button className="save" disabled={saveLoading} onClick={this.handleSave}>
                      保存
                    </Button>
                  </div>
                  <div className="popup_content">
                    <ExamItem
                      {...this.props}
                      ref={this.examItemRef}
                      data={data}
                    />
                  </div>
                </div>
              </Popup>
            )
          : fullPageVisible && (
              <div className="fullPage" id="fullPageContent">
                <div className="fullPageHead">
                  <img
                    src={Back}
                    onClick={() => this.handleFullPageHidden(false)}
                  />
                  <div className="examName">{examName}</div>
                </div>
                <ExamItem {...this.props} ref={this.examItemRef} data={data} />

                {data.isReview === '1' ? (
                  <div className="review_bottom">
                    {/* <div className="exchange" onClick={this.exchangeLens}>
                      换片
                    </div> */}
                    <Button className="review_save"  disabled={saveLoading} onClick={this.handleSave}>
                      保存
                    </Button>
                  </div>
                ) : (
                  <Button className="save"  disabled={saveLoading} onClick={this.handleSave}>
                    保存
                  </Button>
                )}
              </div>
            )}
      </div>
    );
  }
}

export default ExamineTemplate;
